import { render, staticRenderFns } from "./DatabaseRequest.vue?vue&type=template&id=45dd1ffb"
import script from "./DatabaseRequest.vue?vue&type=script&lang=js"
export * from "./DatabaseRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports